import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '../components/icons/NavIcons';
import PageHeader from '../components/PageHeader';

const TermsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <PageHeader title={t('terms.title')} />

      {/* Contenu des CGU et CGV */}
      <div className="p-4 space-y-6">
        {/* CGU */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-h2 text-bleu2 mb-4">
            {t('terms.termsOfUse.title')}
          </h2>

          <div className="space-y-6 text-gray-700">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((num) => (
              <section key={`tou-${num}`}>
                <h3 className="text-h3 mb-2">
                  {t(`terms.termsOfUse.section${num}.title`)}
                </h3>
                <p>{t(`terms.termsOfUse.section${num}.content`)}</p>
              </section>
            ))}
          </div>
        </div>

        {/* CGV */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-h2 text-bleu2 mb-4">
            {t('terms.termsOfSale.title')}
          </h2>

          <div className="space-y-6 text-gray-700">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
              <section key={`tos-${num}`}>
                <h3 className="text-h3 mb-2">
                  {t(`terms.termsOfSale.section${num}.title`)}
                </h3>
                <p>{t(`terms.termsOfSale.section${num}.content`)}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
